import {Button} from 'react-bootstrap'
import {KTIcon} from '../_metronic/helpers'

function EditBtn() {
  return (
    <Button variant="outline-secondary" size="sm" className="px-2">
      <KTIcon iconName="pencil" className="text-primary fs-2 p-0" />
    </Button>
  )
}

export default EditBtn
